import { sample } from 'effector';
import { $editingHotspot } from '@stores/editingHotspotStores';
import domain from '../domain';
import krpRemoveHotspot from './krpRemoveHotspot';
import krpAddHotspot from './krpAddHotspot';
import toggleHotspotSelected from './toggleHotspotSelected';

const reAddEditingHotspot = domain.event();

sample({
  source: $editingHotspot,
  clock: reAddEditingHotspot,
}).watch((editing) => {
  const hotspot = editing?.hotspot;
  if (!hotspot) return;
  if (!editing.isBatch) {
    krpRemoveHotspot(hotspot.id);
    krpAddHotspot(hotspot);
    toggleHotspotSelected({
      id: hotspot.id,
      isOn: true,
    });
  } else if (editing.batchHotspots) {
    editing.batchHotspots.forEach((x) => {
      krpRemoveHotspot(x.id);
      krpAddHotspot(x);
      toggleHotspotSelected({
        id: x.id,
        isOn: true,
      });
    });
  }
});

export default reAddEditingHotspot;
